import { EnquiryLayout } from './components';
import { useEnquiryContext } from './context';

const EnquiryContent: React.FunctionComponent = function () {
  const { isLoading, Content } = useEnquiryContext();
  return <EnquiryLayout isLoading={isLoading}>{Content}</EnquiryLayout>;
};

export default EnquiryContent;
